import React, { useState, useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";
import Layout from "components/Layout";
import ValidSession from "components/ValidSession";
import CouponSlider from "components/CouponSlider";
import PopupLayout from "components/PopupLayout";
import PopupConfirmChange from "components/PopupConfirmChange";
import SessionFactory from "factories/Session";
import CartService from "services/Cart/service";
import IconClose from "assets/images/category/icon-close.png";
import { CartContext } from "../../cart/CartContext";
import "./style.scss";
import { types } from "../../types/types";
import { main_links } from "config";
import PopupLimiteHCanjearLiberar from "components/PopupLimiteHCanjearLiberar";

const AccountCoupons = () => {
    const { cartData, cartDispatch } = useContext(CartContext);
    const [loadData, setLoadData] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [dataPage, setDataPage] = useState({});
    const [cartCoupons, setCartCoupons] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showLimiteHCanjear, setShowLimiteHCanjear] = useState(false);
    const [cantCupTotalLHCanjear, setCantCupTotalLHCanjear] = useState();
    const [cantCupConsumidosLHCanjear, setCantCupConsumidosLHCanjear] = useState();
    const [pathRedirect, setPathRedirect] = useState("");

    const openConfirmation = (event, forceValue = "none") => {
        event.preventDefault();
        if (isProcessing) return;
        setShowConfirmation(
            forceValue === "none" ? !showConfirmation : forceValue
        );
    };
    const confirmChangeCoupons = () => {
        if (isProcessing) return;
        setIsProcessing(true);

        Promise.all([
            CartService.releaseCart({
                carrito: cartData.id,
            }),
        ]).then((cartFree) => {
            if (cartFree && ["200", "201"].includes(cartFree[0].internalCode)) {
                cartDispatch({
                    type: types.update,
                    payload: {
                        ...cartData,
                        state: "L",
                    },
                });
                setPathRedirect(`/account-coupons-change/${cartData.id}`);
            }
        });
    };
    useEffect(() => {
        setDataPage({ session: SessionFactory.validation() });
        setLoadData(true);

        Promise.all([CartService.getLastCart()]).then((cartLast) => {
            if (cartLast && ["200", "201"].includes(cartLast[0].internalCode)) {
                localStorage.setItem("maxLimit", cartLast[0].payload.maxItems);
                const coupons = cartLast[0].payload;
                //popup canjear LH
                if (coupons.cantCupConsumidosTotalLH > 0) {
                    valuePopupLimiteCanjear(
                        true,
                        coupons.cantCupConsumidosTotalLH,
                        coupons.cantCupTotalLH
                    );
                }
                //
                if (coupons.estado === "A") {
                    setCartCoupons(coupons.detalle);
                }
            } else {
                setCartCoupons([]);
            }
        });

        if (sessionStorage.getItem("autoConfirmation")) {
            setShowConfirmation(true);
            sessionStorage.removeItem("autoConfirmation");
        }
    }, []);

    const openLimiteHCanjear = (event, forceValue = "none") => {
        event.preventDefault();
        setShowLimiteHCanjear(
            forceValue === "none" ? !showLimiteHCanjear : forceValue
        );
    };
    const valuePopupLimiteCanjear = (showValue, cupConsumidos, cupTotal) => {
        setShowLimiteHCanjear(showValue);
        setCantCupConsumidosLHCanjear(cupConsumidos);
        setCantCupTotalLHCanjear(cupTotal);
    };

    return (
        <div className="mi-cuenta cupones is-logged">
            {loadData && (
                <ValidSession
                    dataSession={dataPage.session && dataPage.session}
                />
            )}
            <Layout
                dataPage={dataPage}
                showContent={loadData && dataPage.session ? true : false}
                showBanner={false}
            >
                <section className="coupons-search">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 pt-4 pb-4">
                                <div className="row pl-2 pr-2">
                                    <div className="col-10 col-lg-6 d-flex justify-content-lg-start align-content-center">
                                        <p className="text-left red-dark m-0 my-auto">
                                            <strong>
                                                Tus cupones seleccionados,
                                                <br />
                                                listos para canjear:
                                            </strong>
                                        </p>
                                    </div>
                                    <div className="col-2 col-lg-6 d-flex justify-content-center justify-content-lg-end align-content-center">
                                        <p className="text-center m-0 my-auto">
                                            <a href={main_links.main_logged}>
                                                <img src={IconClose} />
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="coupons">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 mt-4">
                                {cartCoupons.length > 0 ? (
                                    <CouponSlider
                                        coupons={cartCoupons}
                                        noslick={true}
                                        hasSession={true}
                                        withoutAction={true}
                                        hasCart={false}
                                    />
                                ) : (
                                    <div className="text-center cart-is-empty">
                                        <p>
                                            No tienes cupones seleccionados aún
                                        </p>
                                        <div className="buttons">
                                            <a
                                                href="/home"
                                                className="btn no-hover"
                                            >
                                                <span className="add">
                                                    Agregar cupones
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                {cartCoupons.length > 0 && (
                    <section className="coupons-buttons">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <p className="text-center mt-3 mb-3">
                                        <a
                                            href="#"
                                            onClick={(event) =>
                                                openConfirmation(event)
                                            }
                                            className="btn button-change-coupons black"
                                        >
                                            Canjear cupones
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
                <PopupLayout
                    isShowwing={showConfirmation}
                    showingCallback={openConfirmation}
                >
                    <PopupConfirmChange
                        execActionConfirm={confirmChangeCoupons}
                    />
                </PopupLayout>
                <PopupLayout
                    isShowwing={showLimiteHCanjear}
                    showingCallback={openLimiteHCanjear}
                >
                    <PopupLimiteHCanjearLiberar
                        execActionConfirm={openLimiteHCanjear}
                        cantCupConsumidosLH={cantCupConsumidosLHCanjear}
                        cantCupTotalLH={cantCupTotalLHCanjear}
                    />
                </PopupLayout>
                {pathRedirect !== "" && <Redirect to={pathRedirect} />}
            </Layout>
        </div>
    );
};

export default AccountCoupons;
